class PrintPicker extends HTMLElement {
  connectedCallback() {
    this.prints = Array.prototype.slice.call(this.querySelectorAll('[data-print]'));
    if (!this.prints.length) return;

    this.bar = this.querySelector('[data-print-bar]');
    this.countEl = this.querySelector('[data-print-count]');
    this.totalEl = this.querySelector('[data-print-total]');
    this.noteEl = this.querySelector('[data-print-note]');
    this.errorEl = this.querySelector('[data-print-error]');
    this.addButton = this.querySelector('[data-print-add]');

    this.threshold = parseInt(this.dataset.threshold, 10) || 0;
    this.wordOne = this.dataset.wordOne || '';
    this.wordMany = this.dataset.wordMany || '';
    this.addLabel = this.dataset.addLabel || '';
    this.freeLabel = this.dataset.freeLabel || '';

    this.prints.forEach((print) => {
      print.addEventListener('click', () => this.toggle(print));
      print.addEventListener('keydown', (event) => {
        if (event.key === ' ') {
          event.preventDefault();
          print.click();
        }
      });
    });

    this.tabs = Array.prototype.slice.call(this.querySelectorAll('[data-print-tab]'));
    this.panels = Array.prototype.slice.call(this.querySelectorAll('[data-print-panel]'));

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', () => this.showTab(tab.dataset.printTab));
      tab.addEventListener('keydown', (event) => {
        var i = this.tabs.indexOf(tab);
        var next = null;
        if (event.key === 'ArrowRight') next = this.tabs[(i + 1) % this.tabs.length];
        if (event.key === 'ArrowLeft') next = this.tabs[(i - 1 + this.tabs.length) % this.tabs.length];
        if (!next) return;
        event.preventDefault();
        this.showTab(next.dataset.printTab);
        next.focus();
      });
    });

    if (this.addButton) this.addButton.addEventListener('click', () => this.add());

    this.render();
  }

  showTab(id) {
    this.tabs.forEach((tab) => {
      var on = tab.dataset.printTab === id;
      tab.classList.toggle('is-active', on);
      tab.setAttribute('aria-selected', String(on));
      tab.tabIndex = on ? 0 : -1;
    });
    this.panels.forEach((panel) => {
      panel.hidden = panel.dataset.printPanel !== id;
    });
  }

  get selected() {
    return this.prints.filter((p) => p.dataset.selected === 'true');
  }

  toggle(print) {
    if (print.disabled) return;
    var isOn = print.dataset.selected === 'true';
    print.dataset.selected = isOn ? 'false' : 'true';
    print.classList.toggle('is-on', !isOn);
    print.setAttribute('aria-checked', String(!isOn));
    this.render();
  }

  render() {
    var chosen = this.selected;
    var total = chosen.reduce(function (sum, p) {
      return sum + (parseInt(p.dataset.price, 10) || 0);
    }, 0);

    if (this.bar) this.bar.hidden = chosen.length === 0;
    if (chosen.length === 0) return;

    if (this.countEl) {
      var word = chosen.length === 1 ? this.wordOne : this.wordMany;
      this.countEl.textContent = (chosen.length + ' ' + word).trim();
    }

    if (this.totalEl) this.totalEl.textContent = window.RappitUtils.formatMoney(total);

    if (this.noteEl) {
      var shipsFree = this.threshold > 0 && total >= this.threshold;
      this.noteEl.textContent = shipsFree ? this.freeLabel : '';
      this.noteEl.hidden = !shipsFree;
    }

    if (this.addButton) {
      this.addButton.textContent = (this.addLabel + ' ' + chosen.length).trim();
    }
  }

  add() {
    var items = this.selected
      .filter(function (p) {
        return p.dataset.variant && p.dataset.available === 'true';
      })
      .map(function (p) {
        return { id: p.dataset.variant, quantity: 1 };
      });

    if (!items.length) return;

    this.addButton.setAttribute('aria-busy', 'true');
    this.hideError();

    window.RappitCart.add(items)
      .then(() => {
        if (window.Rappit.cartType === 'drawer') {
          window.RappitDrawers.open('CartDrawer', this.addButton);
        } else {
          window.location.href = window.Rappit.routes.cart;
        }
      })
      .catch((error) => this.showError(error.message))
      .finally(() => this.addButton.setAttribute('aria-busy', 'false'));
  }

  hideError() {
    if (!this.errorEl) return;
    this.errorEl.hidden = true;
    this.errorEl.textContent = '';
  }

  showError(message) {
    if (!this.errorEl) {
      window.RappitUtils.toast(message, 'error');
      return;
    }
    this.errorEl.textContent = message;
    this.errorEl.hidden = false;
  }
}

if (!customElements.get('print-picker')) {
  customElements.define('print-picker', PrintPicker);
}
